<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "shops",
    cardSetLink: "shops",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "organizations",
        label: "Организации (холдинг)",
        labelKey: "holding",
        type: "selects",
        modal: "organization",
        selectKey: "name",
      },
      {
        col: " col-12 col-md-8",
        key: "name",
        label: "Название магазина",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-4",
        label: "Компания",
        labelKey: "company",
        key: "dealer",
        type: "select",
        modal: "dealer",
        selectKey: "name",
      },
      {
        col: " col-12 col-md-12",
        key: "location_id",
        label: "Регион / город",
        type: "location",
      },
      {
        col: " col-12 col-md-12",
        key: "address",
        label: "Адрес магазина",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-12",
        key: "coords",
        label: "Отиетка на карте",
        type: "map",
      },

      {
        col: " col-12 col-md-12",
        key: "partners",
        labelKey: "partners",
        label: "Разрешенные фин. партнеры",
        type: "selects",
        modal: "partner",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
